//#region import libraries
import React, { useEffect, useState } from 'react';

// bootstrap
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';

// styling
import { Colors } from '_styles';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { editProduct, createProduct, selectCreateProductError, selectCreateProductStatus, resetCreateProduct, selectCreateProduct } from '_redux/slices/marketplace/create-product';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { uploadImage, selectPostedImage, selectImageStatus, reset } from '_redux/slices/prm-club/rewards';

// custom components
import { CustomSpinner, IconPageTitle, ErrorMessage } from '_atoms';

// icons
import { AiOutlineCloudUpload } from "react-icons/ai";
import { CiShop } from "react-icons/ci";

// tremor
import { Flex } from '@tremor/react';
import { getRetailersTitles, selectOneRetailer } from '_redux/slices/marketplace/retailer';
//#endregion


const ProductForm = (props) => {
    //#region redux
    // redux
    const dispatch = useDispatch();
    //RETAILER REDUX
    const selectedRetailer = useSelector(selectOneRetailer);
    // product redux   
    const product = useSelector(selectCreateProduct);

    const createProductStatus = useSelector(selectCreateProductStatus);
    const productError = useSelector(selectCreateProductError);

    // image redux
    const imageStatus = useSelector(selectImageStatus);
    const uploadedImage = useSelector(selectPostedImage);

    // user redux
    const userDb = useSelector(selectUserDb);
    //retailer redux
    const retailersTitles = useSelector(getRetailersTitles)

    //#endregion

    //#region local state   

    const [imageLoading, setImageLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [enableAdding, setEnableAdding] = useState(false); // this state to prevent any auto adding after open the page, first time
    //image states
    const [imagePreview, setImagePreview] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    // border colors
    const [retailerTitleBorder, setRetailerTitleBorder] = useState('grey');
    const [productTitleBorder, setProductTitleBorder] = useState('grey');
    const [descriptionBorder, setDescriptionBorder] = useState('grey');
    const [categoryBorder, setCategoryBorder] = useState('grey');
    const [imageBorder, setImageBorder] = useState('grey');
    const [productFieldsValues, setProductFieldsValues] = useState({
        retailerId: userDb?.role === "RETAILER" && selectedRetailer ? selectedRetailer?._id : product?.retailerId || "",
        retailerName: userDb?.role === "RETAILER" && selectedRetailer ? selectedRetailer?.retailerName : product?.retailerId || "",
        // retailerId: product?.retailerId || '',
        productTitle: product?.productTitle || '',
        description: product?.description || '',
        category: product?.category || 'DEFAULT',
    })
    //#endregion

    //#region useEffect
    // reset 
    useEffect(() => {
        dispatch(resetCreateProduct());

        dispatch(reset());
        setErrors({})
    }, []);

    // image upload listener
    useEffect(() => {
        if (imageStatus == 'loading') {
            // image is being uploaded
            setImageLoading(true);
        }

        //if image is being uploaded, then submit form
        if (imageStatus === "succeeded" && enableAdding) {
            handleSubmit()
        }
    }, [imageStatus]);


    // reset product fields if creating product was successful
    useEffect(() => {
        if (createProductStatus === 'succeeded') { //should handle update case!!
            setProductFieldsValues({
                retailerId: '',
                productTitle: '',
                description: '',
                category: "DEFAULT"
            })
        }
    }, [createProductStatus])
    //#region functions

    //handle fields validation
    const validateFields = (fields) => {
        let tempErrors = {};

        const { retailerId, productTitle, description, category } = fields;
        //check retailer title
        if ((userDb.role !== "RETAILER" && !retailerId?.length) || retailerId === "DEFAULT") {
            tempErrors.retailerId = 'Retailer name is required';
            setRetailerTitleBorder("red")
        } else { setRetailerTitleBorder("green") }
        //check product title
        if (!productTitle.length) {
            tempErrors.productTitle = 'Product Title is required';
            setProductTitleBorder("red")
        } else { setProductTitleBorder("green") }
        //check description
        if (!description.length) {
            tempErrors.description = 'Product Description is required';
            setDescriptionBorder("red")
        } else { setDescriptionBorder("green") }
        //check category 
        if (category === 'DEFAULT' || !category.length) {
            tempErrors.category = 'Product Category is required';
            setCategoryBorder("red")
        } else { setCategoryBorder("green") }
        //check image if it's uploaded
        if (!selectedImage) {
            tempErrors.image = 'Image is required';
            setImageBorder("red")
        } else { setImageBorder("green") }
        setErrors(tempErrors);
        return tempErrors
    };

    function generateProductId() {
        //RETAILER_maad-prm-product_maad-prm
        return userDb.details.authority + '_' + productFieldsValues.productTitle.trim().replace(/\s+/g, '-') + '_' + productFieldsValues.retailerId
    }
    // handle create product
    //id need some convention
    const handleSubmit = () => {

        const databaseObject = {
            ...productFieldsValues,
            image: uploadedImage,
            iata: userDb.details.authority,
            userId: userDb.firebaseId,
            id: generateProductId()
        }
        dispatch(editProduct(databaseObject));          // add all details to redux slice
        props.submitted();
        dispatch(createProduct(databaseObject));        // post to db   
        setEnableAdding(false)
    }

    // handle back button press
    const handleBackButton = () => {
        props.back();
    }


    //On clicking create; upload image then  submit the product with image
    const handlePreSubmit = () => {
        const valideForm = validateFields(productFieldsValues);
        if (!Object.keys(valideForm).length) {
            dispatch(uploadImage(selectedImage))
            setEnableAdding(true)
        }
    }
    //save image in state, remove image error
    const handleImageSelect = (image) => {
        setSelectedImage(image);
        setImagePreview(URL.createObjectURL(image)); // Generate a preview
        if (errors.image) {
            delete errors.image;
            setImageBorder('green')
        }
    };

    const handleChangeInput = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        // Update the state and pass the updated fields to validateFields
        setProductFieldsValues((prevState) => {
            const updatedFields = { ...prevState, [name]: value };
            // Call validateFields with updated state
            validateFields(updatedFields);

            return updatedFields;
        });
    };
    //#endregion

    return (
        <Row>
            <Flex>
                {/* Title */}
                <IconPageTitle title={"Add Product Details"} subtitle={"Fill in the information about your product below to create a PRM Marketplace Listing"} icon={<CiShop size={80} color={Colors.PRM_LIGHT_BLUE} />} back={handleBackButton} topText={"Step 1."} />

                {/* Button */}
                <div>
                    <Button variant={productError || Object.keys(errors).length > 0 ? "danger" : "primary"} onClick={handlePreSubmit} loading={false} style={{ width: 200 }} className="mt-2">{createProductStatus === 'loading' || imageStatus == 'loading' ? <CustomSpinner size={'sm'} style={{ color: 'white' }} /> : 'Create Product'}</Button>
                </div>
            </Flex>

            <Container className='mt-3'>
                <hr style={{ borderColor: Colors.PRM_LIGHT_BLUE }} />
            </Container>

            {productError &&
                <Container>
                    <ErrorMessage
                        title={"Error Creating Product"}
                        error={productError}
                    />
                </Container>
            }

            {/* Title */}
            <Form.Group className='mt-4'>
                <Row>
                    <Col>
                        <Form.Label style={{ color: retailerTitleBorder }}>Retailer</Form.Label>
                        {userDb && userDb.role === "RETAILER" ?
                            <Form.Control disabled={true} value={productFieldsValues.retailerName} name="retailerTitle" type="name" style={{ borderColor: "green" }} />
                            :
                            <Form.Select aria-label="Floating label select example" onChange={handleChangeInput} name='retailerId' value={productFieldsValues.retailerId} style={{ borderColor: retailerTitleBorder }}>
                                <option value="DEFAULT">Select Retailer</option>
                                {retailersTitles.map((retailer) => {
                                    return <option key={retailer.id} value={retailer.id}>{retailer.title}</option>
                                })}
                            </Form.Select>}
                        {errors.retailerId && (<p className="text-danger">{errors.retailerId}</p>)}

                    </Col>
                    <Col>
                        <Form.Label style={{ color: productTitleBorder }}>Product Title</Form.Label>
                        <Form.Control onChange={handleChangeInput} value={productFieldsValues.productTitle} name="productTitle" type="name" placeholder="Enter the product title" style={{ borderColor: productTitleBorder }} />
                        {errors.productTitle && (<p className="text-danger">{errors.productTitle}</p>)}
                    </Col>
                </Row>
            </Form.Group>

            {/* Description */}
            <Form.Group className="mt-4">
                <Row>
                    <Col>
                        <Form.Label style={{ color: descriptionBorder }}>Product Description</Form.Label>
                        <Form.Control as="textarea" type="text" placeholder="Type a description of the club Product..." onChange={handleChangeInput} name="description" value={productFieldsValues.description} style={{ borderColor: descriptionBorder, height: '100px' }} />
                        {errors.description && (<p className="text-danger">{errors.description}</p>)}
                    </Col>
                    <Col>
                        <Form.Label style={{ color: categoryBorder }}>Product Category</Form.Label>
                        <Form.Select aria-label="Floating label select example" onChange={handleChangeInput} name='category' value={productFieldsValues.category} style={{ borderColor: categoryBorder }}>
                            <option value="DEFAULT">Select a Category</option>
                            {userDb.role == 'GARETH' && <option value="SHOP">Shopping</option>}
                            <option value="FOOD">Food & Drink</option>
                            <option value="EXCLUSIVE">Exclusive Products</option>
                            <option value="ONBOARD">Onboard</option>
                        </Form.Select>
                        {errors.category && (<p className="text-danger">{errors.category}</p>)}
                    </Col>
                </Row>
            </Form.Group>

            {/* Image */}
            <Form.Group className='mt-5'>
                <Row>
                    <Col>
                        {/* File Input */}
                        <Form.Label style={{ color: imageBorder }}>Image Input</Form.Label>
                        <Form.Control type="file" onChange={(e) => { handleImageSelect(e.target.files[0]) }} accept="image/*" style={{ borderColor: imageBorder }} />
                        {errors.image && (<p className="text-danger">{errors.image}</p>)}
                    </Col>
                    <Col>
                        <Flex>
                            <Form.Label style={{ color: imageBorder }}>Product Image</Form.Label>
                            {
                                imageLoading == true || imageLoading == true ? <div style={{}}><CustomSpinner size={true} rowCenter={true} /></div>
                                    : imageStatus == 'succeeded' ? <div style={{ display: 'flex' }}><p style={{ color: 'green', fontWeight: '300' }}>Uploaded Successfully</p><AiOutlineCloudUpload size={32} color={'green'} style={{ paddingBottom: 12 }} /></div> : " "
                            }
                        </Flex>
                        <div style={{ height: 350 }} className="border">
                            {
                                selectedImage == undefined ?
                                    <div style={{ textAlign: 'center' }}>
                                        <p style={{ color: 'white' }}>s</p>
                                        <p style={{ fontSize: 18, opacity: 0.4, fontWeight: '300', marginTop: 100 }}>Select the 'choose file' button below to add an image for the club Product</p>
                                    </div>
                                    :
                                    <img src={imagePreview} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 15 }} onLoad={() => { setImageLoading(false) }} />
                            }
                        </div>
                    </Col>
                </Row>
            </Form.Group>

        </Row>
    );
};

export default ProductForm;
